var _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTime1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "url(#paint0_linear_22_12)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0656 12.4224L12.6668 11.6152V8.66659C12.6668 8.48977 12.5966 8.3202 12.4716 8.19518C12.3465 8.07016 12.177 7.99992 12.0002 7.99992C11.8234 7.99992 11.6538 8.07016 11.5288 8.19518C11.4037 8.3202 11.3335 8.48977 11.3335 8.66659V11.9999C11.3335 12.117 11.3643 12.232 11.4228 12.3333C11.4813 12.4347 11.5655 12.5189 11.6668 12.5774L13.3989 13.5774C13.4748 13.6212 13.5585 13.6497 13.6453 13.6611C13.7322 13.6726 13.8204 13.6668 13.905 13.6442C13.9896 13.6215 14.0689 13.5824 14.1384 13.5291C14.2079 13.4758 14.2662 13.4093 14.31 13.3334C14.3538 13.2576 14.3822 13.1738 14.3936 13.087C14.4051 13.0001 14.3992 12.9119 14.3765 12.8273C14.3538 12.7427 14.3147 12.6634 14.2613 12.5939C14.208 12.5245 14.1415 12.4662 14.0656 12.4224ZM12.0002 5.33325C10.6816 5.33325 9.39269 5.72425 8.29636 6.45679C7.20004 7.18933 6.34555 8.23052 5.84097 9.4487C5.33638 10.6669 5.20436 12.0073 5.4616 13.3005C5.71883 14.5937 6.35377 15.7816 7.28612 16.714C8.21847 17.6463 9.40636 18.2813 10.6996 18.5385C11.9928 18.7957 13.3332 18.6637 14.5514 18.1591C15.7696 17.6545 16.8108 16.8 17.5433 15.7037C18.2758 14.6074 18.6668 13.3185 18.6668 11.9999C18.6649 10.2324 17.9619 8.53786 16.712 7.28804C15.4622 6.03823 13.7677 5.33522 12.0002 5.33325ZM12.0002 17.3333C10.9453 17.3333 9.91419 17.0205 9.03712 16.4344C8.16006 15.8484 7.47648 15.0154 7.07281 14.0409C6.66914 13.0664 6.56352 11.994 6.76931 10.9594C6.9751 9.92487 7.48305 8.97456 8.22893 8.22868C8.97481 7.4828 9.92512 6.97485 10.9597 6.76906C11.9942 6.56328 13.0666 6.66889 14.0411 7.07256C15.0157 7.47623 15.8486 8.15981 16.4347 9.03688C17.0207 9.91394 17.3335 10.9451 17.3335 11.9999C17.3319 13.4139 16.7695 14.7695 15.7696 15.7694C14.7698 16.7692 13.4142 17.3316 12.0002 17.3333Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22_12",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F00C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307692,
    stopColor: "#AD009B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567308,
    stopColor: "#D30078"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798077,
    stopColor: "#F3005D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F00C3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime1);
export default __webpack_public_path__ + "static/media/time (1).038e1c04e7fcfacb5e15d5cfe7c2021c.svg";
export { ForwardRef as ReactComponent };